<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="mat-form">
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ data.label }}</mat-label>

    <mat-select *ngIf="data.inputType === 'select'" [formControl]="valueCtrl">
      <mat-option *ngFor="let option of data.options" [value]="option.value">
        {{ option.name }}
      </mat-option>
    </mat-select>

    <!-- `matSuffix` has to sit directly on the projected element: wrapping it
         in an <ng-container *ngIf> stops Material projecting it into the
         suffix slot, which drops the toggle below the input. -->
    <input
      *ngIf="data.inputType !== 'select'"
      matInput
      [type]="inputType"
      [formControl]="valueCtrl" />
    <button
      *ngIf="data.inputType === 'password'"
      mat-icon-button
      matSuffix
      type="button"
      (click)="hide = !hide"
      [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
      [attr.aria-pressed]="!hide">
      <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>

    <mat-error *ngIf="valueCtrl.hasError('required')">
      {{ data.label }} is required
    </mat-error>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" class="btn ghost-btn" (click)="cancel()">Cancel</button>
  <button
    type="button"
    class="btn primary-btn"
    [disabled]="valueCtrl.invalid"
    (click)="submit()">
    {{ data.submitButtonText ?? 'Submit' }}
  </button>
</mat-dialog-actions>
